import { Local } from 'service/api'

import { CreateSlice } from './index'

export type LocationState = {
    locationId: number
    location: Local | null
    setLocationId: (id: number) => void
}

export const createLocationSlice: CreateSlice<LocationState> = set => ({
    locationId: -1,
    location: null,
    setLocationId: (id: number) => set({ locationId: id }),
})
